// @ts-nocheck
import { defineStore } from 'pinia';
import promiseDefer from '@/assets/js/deferedPromise';
//Used to allow the parent to resolve the promise

// You can name the return value of `defineStore()` anything you want, but it's best to use the name of the store and surround it with `use` and `Store` (e.g. `useUserStore`, `useCartStore`, `useProductStore`)
// the first argument is a unique id of the store across your application
export const confirmStore = defineStore('confirm', {
	// arrow function recommended for full type inference
	state: () => {
		return {
			show: false,
			topDown: false,
			yesButtonText: 'Yes',
			noButtonText: 'No',
			yesButtonColor: 'primary',
			noButtonColor: 'error',
			bodyText: '',
			header: '',
			titleColor: '',
			persist: false,
			p: null,
			fullWidth: false,
		};
	},
	actions: {
		/**
		 * Displays the snackbar
		 * @param {Object} opts
		 * @param {String} opts.text
		 * @param {String} opts.title
		 * @param {String} opts.yesButtonText
		 * @param {String} opts.noButtonText
		 * @param {String} opts.yesButtonColor
		 * @param {String} opts.noButtonColor
		 * @param {Number} opts.titleColor effects the header color (optional)
		 * @param {Boolean} opts.persistent
		 * @param {Boolean} opts.fullWidth
		 */
		async showAlert(opts) {
			this._reset();
			this.p = new promiseDefer();

			if (typeof opts === 'string') {
				this.bodyText = opts;
				this.show = true;
				return this.p.promise;
			}
			this.bodyText = opts.text;
			this.header = opts.title || '';
			this.titleColor = opts.titleColor || '';
			this.persist = !!opts.persistent;
			this.yesButtonText = opts.yesButtonText || 'Yes';
			this.noButtonText = opts.noButtonText || 'No';
			this.yesButtonColor = opts.yesButtonColor || 'primary';
			this.noButtonColor = opts.noButtonColor || 'error';
			this.fullWidth = opts.fullWidth || false;
			this.show = true;
			this.p.promise.then(() => {
				this.p = null;
			});
			return this.p.promise;
		},
		async hideAlert() {
			this.show = false;
		},
		async _reset() {
			this.show = false;
			this.topDown = false;
			this.yesButtonText = 'Yes';
			this.noButtonText = 'No';
			this.bodyText = '';
			this.header = '';
			this.titleColor = 'info';
			this.yesButtonColor = 'primary';
			this.noButtonColor = 'error';
			this.persist = false;
			this.fullWidth = false;
		},
	},
});
